export enum RoleEnum {
    ADMIN = 0,
    CONTENT_CREATOR = 1,
    CONTENT_CONSUMER = 2,
    DEVELOPER = 3,
	CONTENT_CONSUMER_FAST_FORWARD = 4
}
